import React from 'react';

import CRMApi from '../../../Api/CRM/CRMApi';
import Menu from '../../../Api/Models/Menu';
import useGlobalState from '../../GlobalStateContext';
import ActionButton from '../../elements/ActionButton';
import DeleteButton from '../../elements/DeleteButton';
import EditButton from '../../elements/EditButton';
import Search from '../../elements/Search';
import ViewButton from '../../elements/ViewButton';
import Card from '../../elements/common/Card';
import SortButton from '../../elements/common/SortButton';
import TableHead from '../../elements/common/TableHead';
import TableLoader from '../../elements/common/TableLoader';
import Paginator from '../../elements/paginator';
import { PERMISSION } from '../../helpers/Permissions';
import useAutoPaginator, { UpdateItemsFunction } from '../../hooks/useAutoPaginator';

export default function MenuList() {
    const { items, updateItems, isLoading, auto } = useAutoPaginator<Menu>((page, params) =>
        CRMApi.menus.getAll(page, { params })
    );

    return (
        <>
            <ActionButton url="/menus/create" title="Create new Menu" permissions={[PERMISSION.CREATE_MENU]} />
            <Card title="All menus">
                <Search {...auto.search} />
                <TableLoader isLoading={isLoading}>
                    <table className="table model-list">
                        <TableHead>
                            <div />
                            <SortButton column="id" {...auto.sort} />
                            <SortButton column="name" {...auto.sort} />
                            <SortButton column="slug" {...auto.sort} />
                            <SortButton column="language_id" label="Language" {...auto.sort} />
                        </TableHead>
                        <MenusTableBody menus={items} update={updateItems} />
                    </table>
                    <Paginator {...auto.paginator} />
                </TableLoader>
            </Card>
        </>
    );
}

function MenusTableBody({ menus, update }: { menus: Menu[]; update: UpdateItemsFunction }) {
    const { languageNames } = useGlobalState();

    return (
        <tbody>
            {menus.map((menu) => (
                <tr key={menu.id}>
                    <td>
                        <ViewButton url={`/menus/${menu.id}`} permissions={[PERMISSION.VIEW_MENU]} />
                        <EditButton url={`/menus/${menu.id}/update`} permissions={[PERMISSION.UPDATE_MENU]} />
                        <DeleteButton
                            url={`/crea/api/menus/${menu.id}`}
                            action={update}
                            permissions={[PERMISSION.DELETE_MENU]}
                        />
                    </td>
                    <td>{menu.id}</td>
                    <td>{menu.name}</td>
                    <td>{menu.slug}</td>
                    <td>{languageNames[menu.language_id]}</td>
                </tr>
            ))}
        </tbody>
    );
}
